import React from 'react';
import PropTypes from 'prop-types';

export function SvgPlus({ stroke = '#000000' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          fill={stroke}
          fillRule="nonzero"
          d="M8.66666667 3L8.666 6.666 12.3333333 6.66666667 12.3333333 8.66666667 8.666 8.666 8.66666667 12.3333333 6.66666667 12.3333333 6.666 8.666 3 8.66666667 3 6.66666667 6.666 6.666 6.66666667 3z"
        />
      </g>
    </svg>
  );
}

SvgPlus.propTypes = {
  stroke: PropTypes.string,
};
